"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cernobbio": {
    "791c22fe": [{
      "hkey": "d5aa3c7e",
      "slug": "cernobbio",
      "name": "Cernobbio",
      "primary": true,
      "skipSearch": false
    }],
    "monte-bisbino": [{
      "hkey": "d5aa3c7e",
      "slug": "cernobbio",
      "name": "Cernobbio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f36afcc2": [{
      "hkey": "d5aa3c7e",
      "slug": "cernobbio",
      "name": "Cernobbio",
      "primary": true,
      "skipSearch": false
    }],
    "piazza-santo-stefano": [{
      "hkey": "d5aa3c7e",
      "slug": "cernobbio",
      "name": "Cernobbio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa6451f4": [{
      "hkey": "d5aa3c7e",
      "slug": "cernobbio",
      "name": "Cernobbio",
      "primary": true,
      "skipSearch": false
    }],
    "rovenna": [{
      "hkey": "d5aa3c7e",
      "slug": "cernobbio",
      "name": "Cernobbio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;